import axios from 'axios'
import { BASE_URL } from '@/service_urls'

const gender = {
  gender: () => axios.get(`${BASE_URL}/gender/`)
}

export default gender